(() => {
  if (window.BBAccessories) return;
  const states = new WeakMap();
  const supplierVariants = {
    '63950198866250': { kind: 'tesa' },
    '63950562689354': { kind: 'grip' },
    '63956112474442': { kind: 'plate', capacity: 1 },
    '63956071940426': { kind: 'plate', capacity: 3 },
    '63956112507210': { kind: 'plate', capacity: 6 },
    '63956112539978': { kind: 'plate', capacity: 12 }
  };
  const route = window.Shopify?.routes?.root || '/';
  const json = element => { try { return JSON.parse(element?.textContent || 'null'); } catch { return null; } };
  const count = (value, maximum = 99) => Math.max(1, Math.min(maximum, Math.trunc(Number(value) || 1)));
  const bind = widget => {
    if (widget.dataset.accessoriesBound) return;
    widget.dataset.accessoriesBound = 'true';
    const form = widget.closest('form');
    const root = widget.closest('[data-bb-product-id], [data-bb-designer], [data-birth-proposal]');
    if (!form || !root) return;
    const labels = json(widget.querySelector('[data-accessory-labels]')) || {};
    const choices = [...widget.querySelectorAll('[data-accessory-choice]')];
    const quantity = widget.querySelector('[data-accessory-quantity]');
    const quantityWrap = widget.querySelector('[data-accessory-quantity-wrap]');
    const property = widget.querySelector('[data-accessory-property]');
    const boardQuantity = form.querySelector('[name="quantity"]');
    const select = form.querySelector('[data-bb-variant], [data-material], [data-birth-variant]');
    const variants = json(root.querySelector('[data-bb-variants], [data-designer-variants]')) || [];
    const specs = json(root.querySelector('[data-bb-production-specs]')) || {};
    const format = cents => new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100);
    const state = { widget, form, root, choices, quantity, labels, selected: null, sync: null };
    state.sync = () => {
      const variant = variants.find(item => String(item.id) === select?.value);
      const spec = specs[select?.value];
      const framed = !spec || spec.frame === 'black' || /canvas/i.test(spec.material || '');
      const intro=widget.querySelector('.bb-accessories-intro');
      if(intro){intro.dataset.defaultIntro??=intro.textContent;intro.textContent=framed?'Bij deze uitvoering is de ophanging inbegrepen. Gebruik wandbevestiging die bij jouw muur past.':intro.dataset.defaultIntro;}
      widget.querySelectorAll('.bb-accessories-footnote:not([data-accessory-restriction])').forEach(note=>{note.hidden=framed;});
      const width = Number(spec?.width_mm) || 0, height = Number(spec?.height_mm) || 0;
      const maximum = Math.max(width, height);
      const thickness = Number(spec?.thickness_mm) || 0;
      const material = String(spec?.material || '').toLowerCase();
      const weight = Number.isFinite(spec?.estimated_weight_kg) ? spec.estimated_weight_kg : null;
      const requiresTwo = maximum > 800;
      const plateCount = Math.max(requiresTwo ? 2 : 1, count(quantity.value));
      const weightLine = widget.querySelector('[data-accessory-weight]');
      if (weightLine) { weightLine.hidden=framed; weightLine.textContent = framed ? '' : weight === null ? 'Gewicht nog niet beschikbaar; controleer dit vóór het kiezen van bevestiging.' : 'Geschat paneelgewicht: circa ' + weight.toLocaleString('nl-NL', {minimumFractionDigits:2,maximumFractionDigits:2}) + ' kg, exclusief bevestiging. ' + (requiresTwo ? 'Boven 80 cm adviseert Probo twee ophangplaten. Twee platen dragen samen circa 1,7 × de enkele draagkracht.' : 'Vergelijk dit met de draagkracht per ophangplaat.') ; }

      const panelFrame = spec?.frame === 'black' && !/canvas/.test(material);
      const canvas = /canvas/.test(material);
      widget.classList.toggle('bb-mounting-included', framed);
      const noneLabel = framed ? 'Ophanging inbegrepen' : labels.none;
      const noneDetail = framed ? 'Bij deze uitvoering is de ophanging inbegrepen. Gebruik wandbevestiging die bij jouw muur past.' : labels.noneDetail;
      choices[0].dataset.accessoryLabel = noneLabel;
      widget.querySelector('[data-accessory-none-title]').textContent = noneLabel;
      widget.querySelector('[data-accessory-none-detail]').textContent = noneDetail;
      for (const input of choices.filter(input => input.value !== 'none')) {
        const knownPanel = /forex|dibond/.test(material);
        const compatible = !framed && width > 0 && height > 0 && (input.value === 'tesa' ? knownPanel && width * height <= 240000 : input.value === 'plate' ? knownPanel : thickness >= 2 && thickness <= 10 && maximum <= 800);
        const supplier = supplierVariants[input.dataset.accessoryId];
        const verified = supplier?.kind === input.value;
        input.closest('label').hidden = !compatible;
        const available = input.dataset.baseAvailable === 'true' && Number(input.dataset.accessoryPrice) > 0 && /^\d+$/.test(input.dataset.accessoryId || '');
        const capacity = supplier?.capacity;
        const capacityKnown = input.value !== 'plate' || Number.isFinite(capacity) && capacity > 0;
        const capacityEnough = input.value !== 'plate' || weight !== null && capacityKnown && capacity * (plateCount >= 2 ? 1.7 : 1) >= weight;
        const tesaEnough = input.value !== 'tesa' || weight !== null && weight <= 2;
        input.disabled = !compatible || !available || !verified || !capacityEnough || !tesaEnough;
        input.closest('label').classList.toggle('is-disabled', input.disabled);
        const message = input.closest('label').querySelector('[data-accessory-unavailable]');
        message.hidden = !input.disabled;
        message.textContent = !compatible ? maximum > 800 && !framed ? labels.large : labels.incompatible : !available ? labels.unavailable : !capacityEnough || !tesaEnough ? weight === null ? 'Controleer eerst het paneelgewicht.' : 'Draagkracht te laag voor dit paneel en aantal sets.' : labels.unverified;
        if (input.checked && input.disabled) choices[0].checked = true;
      }
      state.selected = choices.find(input => input.checked && !input.disabled) || choices[0];
      choices.forEach(input => input.closest('label').classList.toggle('is-selected', input === state.selected));
      const paid = state.selected.value !== 'none';
      quantityWrap.hidden = !paid;
      quantity.disabled = !paid;
      quantity.min = state.selected.value === 'plate' && requiresTwo ? '2' : '1';
      if (paid && Number(quantity.value) < Number(quantity.min)) quantity.value = quantity.min;
      property.value = state.selected.dataset.accessoryLabel;
      const accessoryTotal = paid ? Number(state.selected.dataset.accessoryPrice) * count(quantity.value) : 0;
      widget.querySelector('[data-accessory-total]').textContent = variant && variant.price > 0 ? format(variant.price * count(boardQuantity?.value, 99999) + accessoryTotal) : labels.pending;
      root.querySelectorAll('[data-accessory-review]').forEach(review=>{review.textContent=property.value+(paid?' × '+count(quantity.value):'')+' · '+widget.querySelector('[data-accessory-total]').textContent;});
      const restriction = widget.querySelector('[data-accessory-restriction]');
      restriction.hidden = framed || maximum <= 800;
      restriction.textContent = panelFrame ? labels.includedDetail : canvas ? labels.canvasDetail : labels.large;
    };
    states.set(form, state);
    choices.forEach(input => input.addEventListener('change', state.sync));
    quantity.addEventListener('input', state.sync);
    quantity.addEventListener('blur', () => { quantity.value = String(count(quantity.value)); state.sync(); });
    select?.addEventListener('change', () => queueMicrotask(state.sync));
    root.addEventListener('bb:studio-restored', () => queueMicrotask(state.sync));
    root.addEventListener('bb:step-context', state.sync, true);
    boardQuantity?.addEventListener('input', state.sync);
    boardQuantity?.addEventListener('change', state.sync);
    state.sync();
    const editKey = new URL(location.href).searchParams.get('bb_edit');
    if (editKey) fetch(route + 'cart.js').then(response => response.json()).then(cart => {
      const old = cart.items.find(item => item.key === editKey);
      const extra = cart.items.find(item => item.properties?._bb_accessory_for === old?.properties?._bb_design_id);
      const choice = choices.find(input => input.dataset.accessoryId && input.dataset.accessoryId === String(old?.properties?._bb_accessory_variant));
      if (choice && !choice.disabled && extra) { choice.checked = true; quantity.value = String(extra.quantity); state.sync(); }
    }).catch(() => {});
  };
  const submit = async form => {
    const state = states.get(form);
    state?.sync();
    const selected = state?.selected;
    if (!selected || selected.value === 'none') {
      HTMLFormElement.prototype.submit.call(form);
      return;
    }
    if (selected.disabled || !form.reportValidity()) throw Error(state.labels.error);
    const designId = form.querySelector('[name="properties[_bb_design_id]"]')?.value;
    if (!designId) throw Error(state.labels.error);
    const payload = new FormData();
    for (const [name, value] of new FormData(form)) {
      if (name === 'id' || name === 'quantity' || name === 'selling_plan' || name.startsWith('properties[')) payload.append('items[0][' + name.replace(/^properties\[/, 'properties][').replace(/\]$/, '') + ']', value);
    }
    payload.set('items[0][properties][_bb_accessory_variant]', selected.dataset.accessoryId);
    payload.set('items[1][id]', selected.dataset.accessoryId);
    payload.set('items[1][quantity]', String(count(state.quantity.value)));
    payload.set('items[1][properties][_bb_accessory_for]', designId);
    payload.set('items[1][properties][Bij bord]', state.root.querySelector('h1')?.textContent.trim() || '');
    let response;
    try {
      response = await fetch(route + 'cart/add.js', { method: 'POST', body: payload, signal: AbortSignal.timeout(60000) });
      const data = await response.json();
      if (!response.ok) throw Error(data.description || state.labels.error);
      location.assign(route + 'cart');
    } catch (error) {
      try {
        const current = await fetch(route + 'cart.js').then(result => result.json());
        if (current.items.some(item => item.properties?._bb_design_id === designId)) {
          sessionStorage.setItem('bb_accessory_notice', state.labels.partial);
          location.assign(route + 'cart');
          return;
        }
      } catch {
        sessionStorage.setItem('bb_accessory_notice', state.labels.partial);
        location.assign(route + 'cart');
        return;
      }
      throw error;
    }
  };
  window.BBAccessories = { submit };
  document.querySelectorAll('[data-bb-accessories]').forEach(bind);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bb-accessories]').forEach(bind));
})();
